import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import { ExtendedTasksResponse } from 'app/console-api/tasks/tasks-extended';
import Select from 'react-select';
import { StatisticsFiltersStyles } from 'app/components/common/common-styles';

type TaskOption = {
  id: string;
  value: string;
  label: string;
};

export const TaskListFilterAdapter: FilterAdapter<string[]> = {
  key: 'tasks',
  fromUrl: (sp) => {
    const raw = sp.get('tasks');
    if (!raw) return null;
    const arr = raw
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    return arr.length ? arr : null;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value || value.length === 0) {
      next.delete('tasks');
    } else {
      next.set('tasks', value.join(','));
    }
    return next;
  },
  toKey: (v) => `tasks:${v && v.length ? [...v].sort().join(',') : 'all'}`
};

type TaskListFilterProps = {
  tasks: ExtendedTasksResponse[];
} & Record<string, any>;

export const TaskListFilter = ({ tasks, props }: TaskListFilterProps) => {
  const ctl = useUrlFilterController();
  const value = ctl.get(TaskListFilterAdapter) ?? []; // string[] of selected task IDs
  const options: TaskOption[] = tasks.map((task) => ({
    id: task.task.id,
    value: task.task.id,
    label: task.task.name
  }));

  // react-select multi expects an array of option objects
  const selected = options.filter((o) => value.includes(o.value));

  return (
    <Select<TaskOption, true>
      styles={StatisticsFiltersStyles()}
      {...props}
      placeholder={'All Tasks'}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      isSearchable={false}
      options={options}
      value={selected}
      onChange={(opts: any) => {
        const selectedTaskIds = opts ? opts.map((o: any) => o.value) : [];
        ctl.set(TaskListFilterAdapter, selectedTaskIds.length ? selectedTaskIds : null);
      }}
    />
  );
};
